<template>
  <div class="max-w-xl flex flex-col gap-6 m-auto">
    <ChargebackSearch
      @searchClick="searchClick"
      @refreshClick="fetchWithParams"
      @selectedStatus="fetchWithParams"
      :status="status"
      :transactionId="transactionId"
    />
    <DueChargebacks v-if="shouldDisplayDueChargebacks" />
    <ChargebackList @pageHandler="pageHandlerChargebackList" />
  </div>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'Chargebacks',
  data () {
    return {
      status: undefined,
      transactionId: ''
    }
  },
  components: {
    DueChargebacks: () => import('./List/DueChargebacks.vue'),
    ChargebackList: () => import('./List/ChargebackList.vue'),
    ChargebackSearch: () => import('./List/ChargebackSearch.vue')
  },
  computed: {
    ...mapGetters(['loadingChargebacks']),
    shouldDisplayDueChargebacks () {
      return !this.hasParams
    },
    hasParams () {
      return !!this.status?.length || this.transactionId
    }
  },
  methods: {
    ...mapActions({
      getAllChargebacks: 'GET_ALL_CHARGEBACKS'
    }),
    fetchWithParams (status) {
      this.transactionId = ''
      this.status = status

      this.getAllChargebacks({ status })
    },
    searchClick (transactionId) {
      this.transactionId = transactionId
      this.getAllChargebacks({ transactionId })
    },
    pageHandlerChargebackList (page) {
      this.getAllChargebacks({ page, status: this.status })
      this.transactionId = ''
    }
  }
}
</script>
